const SYNTHETIC_TILED_ASSET_ID_PATTERN = /_gid_\d+$/;

export function isSyntheticTiledMapObjectAssetId(assetId: string | null | undefined): boolean {
  return typeof assetId === 'string' && SYNTHETIC_TILED_ASSET_ID_PATTERN.test(assetId);
}
